import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";
import { Phone, LayoutDashboard, Calendar, PhoneCall, LogOut } from "lucide-react";
import { logoutBdc } from "@/Calls/callBdcAuth";

const navLinks = [
    { to: "/bdc/dashboard",    icon: LayoutDashboard, label: "Dashboard"    },
    { to: "/bdc/calls",        icon: PhoneCall,       label: "Calls"        },
    { to: "/bdc/appointments", icon: Calendar,        label: "Appointments" },
];

export default function BdcLayout() {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = async () => {
        try { await logoutBdc(); } catch { /* ignore */ }
        navigate("/bdc/login");
    };

    return (
        <div className="min-h-screen flex bg-gray-50">
            <aside className="w-60 bg-slate-900 text-white flex flex-col">
                <div className="px-5 py-6 border-b border-slate-700">
                    <div className="flex items-center gap-2">
                        <Phone className="h-5 w-5 text-cyan-400" />
                        <span className="font-semibold text-sm">BDC Portal</span>
                    </div>
                </div>

                <nav className="flex-1 px-3 py-4 space-y-1">
                    {navLinks.map(({ to, icon: Icon, label }) => {
                        const active = location.pathname === to || location.pathname.startsWith(to + "/");
                        return (
                            <Link
                                key={to} to={to}
                                className={`flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${
                                    active
                                        ? "bg-cyan-700 text-white"
                                        : "text-slate-300 hover:bg-slate-800 hover:text-white"
                                }`}
                            >
                                <Icon className="h-4 w-4" />
                                {label}
                            </Link>
                        );
                    })}
                </nav>

                <div className="px-3 py-4 border-t border-slate-700">
                    <button
                        onClick={handleLogout}
                        className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-slate-300 hover:bg-slate-800 hover:text-white transition-colors w-full"
                    >
                        <LogOut className="h-4 w-4" />
                        Sign Out
                    </button>
                </div>
            </aside>

            <main className="flex-1 overflow-auto">
                <div className="p-6 max-w-5xl mx-auto">
                    <Outlet />
                </div>
            </main>
        </div>
    );
}
